export function scrollDetect() {
  // start
  var lastScrollTop = 0;
  $(window).scroll(function(){
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
      $('body').removeClass('scrolledUp').addClass('scrolledDown');
    } else {
      $('body').removeClass('scrolledDown').addClass('scrolledUp');
    }
    lastScrollTop = st;
  });
  // end
}



// WEBPACK FOOTER //
// ./scripts/includes/scroll-detect.js